import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { path } from '../../../constants';
import { useDefaultContext } from '../../../contexts/UserContext';
import { MainLogo, QueryIcon } from '../../../assets/svg';
import NotificationModal from './NotificationModal';
import ProfileDropdown from './ProfileDropdown';
import MobileSidebar from '../../MobileSideBar';
import useEffectOnce from '../../../hooks/useEffectOnce';
import HeaderLogo from '../../../assets/images/logo1.png';
import './Header.scss';

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { introspectToken } = useDefaultContext();
  const accessToken = localStorage.getItem('access_token');
  const { getUserProfile } = useDefaultContext();

  const handleLogo = () => {
    navigate(path.PERSONAL_INFO);
  };

  useEffectOnce(() => {
    
    if (accessToken) {
      
      firstApiCall()
     
    }
  });

  async function firstApiCall(){
    await getUserProfile()
    await introspectToken()

  }

  return (
    <div
      className={`${location.pathname === "/edit-personal-info" ? 'hide' : "show"}`}
    >
      <div className="header">
        <div className="header-logo" onClick={handleLogo}>
          <img alt="logo" src={MainLogo} className="logo" />
        </div>
        <div className="header-content-wrapper">
          {/* <NotificationModal /> */}
          {/* <QueryIcon /> */}
          <ProfileDropdown />
        </div>
      </div>
      <MobileSidebar />
    </div>
  );
}
